export const COMMERCETOOLS_ACCESS_TOKEN_URL = "https://auth.europe-west1.gcp.commercetools.com";
export const COMMERCETOOLS_API_URL = "https://api.europe-west1.gcp.commercetools.com";
export const COMMERCETOOLS_MERCHANT_CENTER_URL = `https://mc.europe-west1.gcp.commercetools.com/${process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY}`;
export const COMMERCETOOLS_PROJECT_API_URL = `${COMMERCETOOLS_API_URL}/${process.env.NEXT_PUBLIC_COMMERCETOOLS_PROJECT_KEY}`;
export const STORE_FRONT_EMAIL_SUBSCRIPTION_ENDPOINT = "Consent/newslettersignup";
export const STORE_FRONT_SESSION_ENDPOINT = "payment/session";
export const STORE_FRONT_CREATE_ORDER_ENDPOINT = "payment/order";
export const STORE_FRONT_CREATE_AMAZON_PAY_ORDER_ENDPOINT = "payments/amazon-pay";
export const STORE_FRONT_CREATE_ORDER_WITH_TOTAL_ZERO_ENDPOINT = "payment/zeroAmountOrder";
export const STORE_FRONT_CREATE_ORDER_WITH_DEFERRED_PAYMENT_ENDPOINT =
    "payment/orderWithDeferredPayment";
export const STORE_FRONT_PAYMENTS_DETAILS_ENDPOINT = "payment/details";
export const STORE_FRONT_PAYMENTS_ENDPOINT = "payment";
export const STORE_FRONT_PAYMENT_METHODS_ENDPOINT = "payment/methods";
export const STORE_FRONT_ORDER_HISTORY_ENDPOINT = "Order/OrderHistory";
export const STORE_FRONT_CREATE_TRY_AND_BUY_ORDER = "Order/TryBuy";
export const STORE_FRONT_PAYMENT_STATUS_ENDPOINT = "payment/status";
